import { Injectable, EventEmitter, NgZone }     from '@angular/core';
import {TrackerService} from './tracker';

declare let window: any;

window.onOAuthComplete = function(qs) {
  if (qs.error) throw new Error(qs.error);
  window.secretService.oauthFinished(qs);
}

const OAUTH_CALLBACK = window.config.oauth.callback_url ||
        window.location.protocol + '//' + window.location.host + (window.config.basePath || '/') + 'oauth_callback.html';

@Injectable()
export class SecretService {
  secrets:any={};
  hasSecurity:boolean;
  onOAuthFinished:Function;
  oauthSettings:any = {};
  onChange:EventEmitter<any> = new EventEmitter();
  constructor(private zone:NgZone, private tracker:TrackerService) {
    window.secretService = this;
  }

  setSecrets(secrets) {
    this.tracker.track('authenticate', {keys: Object.keys(secrets).join(',')});
    this.zone.run(() => {
      for (let key in secrets) this.secrets[key] = secrets[key];
      this.onChange.emit(this.secrets);
    });
  }

  clearSecrets() {
    this.secrets = {};
    this.setSecrets({});
  }

  startOAuth(host, clientId, securityDefinition, scopes) {
    let flow = securityDefinition.flow;
    let url = securityDefinition.authorizationUrl;
    let state = Math.random();
    let redirect = OAUTH_CALLBACK;
    this.oauthSettings = {
      host, clientId,
    }
    url += '?response_type=' + (flow === 'implicit' ? 'token' : 'code');
    url += '&redirect_uri=' + redirect;
    url += '&client_id=' + encodeURIComponent(clientId);
    if (scopes.length > 0) {
      url += '&scope=' + encodeURIComponent(scopes.join(' '));
    }
    url += '&state=' + encodeURIComponent(state.toString());
    this.tracker.track('start_oauth', {authURL: url, scope: scopes});
    window.open(url, '_blank');
    return new Promise((resolve, reject) => {
      this.oauthSettings.promise = {resolve, reject};
    });
  }

  oauthFinished(qs) {
    if (this.onOAuthFinished) {
      this.onOAuthFinished(qs);
      this.onOAuthFinished = null;
      return
    } else if (qs.error) {
      this.oauthSettings.promise.reject(new Error(qs.error));
      return;
    }
    if (qs.access_token) {
      this.setSecrets({oauth2: qs.access_token});
      this.oauthSettings.promise.resolve();
    } else {
      let tokenURL = window.config.oauth.token_url;
      tokenURL += '?code=' + qs.code;
      tokenURL += '&host=' + encodeURIComponent(this.oauthSettings.host);
      tokenURL += '&client_id=' + encodeURIComponent(this.oauthSettings.clientId);
      tokenURL += '&redirect_uri=' + encodeURIComponent(OAUTH_CALLBACK);
      window.jQuery.ajax({
        method: 'POST',
        url: tokenURL,
        headers: {'Content-Type': 'application/json'},
      }).done(data => {
        this.setSecrets({oauth2: data.access_token});
        this.oauthSettings.promise.resolve();
      }).fail(xhr => {
        this.oauthSettings.promise.reject(new Error(xhr.responseText));
      });
    }
  }

  isAuthenticated(operation=null) {
    if (!this.hasSecurity) return true;
    if (operation) {
      if (!operation.security || !operation.security.length) return true;
      // TODO: confirm that secrets conform to one of operation.securty
    }
    return !!Object.keys(this.secrets).filter(k => this.secrets[k]).length;
  }

  startAuthentication() {
    if (window.lucybot.startLogin) {
      window.lucybot.startLogin();
    } else {
      this.onOAuthFinished = null;
      window.jQuery('#AuthenticationModal').modal('show');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/secret.ts